import { render, staticRenderFns } from "./MaterialInfo.vue?vue&type=template&id=2061f76e&scoped=true"
import script from "./MaterialInfo.vue?vue&type=script&lang=js"
export * from "./MaterialInfo.vue?vue&type=script&lang=js"
import style0 from "./MaterialInfo.vue?vue&type=style&index=0&id=2061f76e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2061f76e",
  null
  
)

export default component.exports